import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import Footer from 'components/Footer/Footer.jsx';
// sections for this page
import NavigationBar from 'components/inc/NavigationBar.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import projectListPageStyle from 'assets/jss/projectListPageStyle.jsx';
import styles from 'assets/jss/customStyle.jsx';
import 'react-bootstrap-wizard/dist/react-wizard.scss';
import 'components/StepWizard/stepWizardStyle.scss';
import { Route, Switch, withRouter } from 'react-router-dom';
import Button from 'components/CustomButtons/Button.jsx';
import PageTitle from 'components/inc/PageTitle.jsx';
import LoadingComponent from 'components/inc/LoadingComponent';
import { connect } from 'react-redux';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getProjectDetails } from '../../actions/project';
import _ from 'lodash-es';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ProjectForm from '../../components/StepWizard/Project/ProjectForm';
import SprintForm from '../../components/StepWizard/Sprint/SprintForm';
import Sprint from '../../components/StepWizard/Sprint/Sprint';
import SprintListUser from '../../components/SprintList/SprintListUser.jsx';
import Container from '@material-ui/core/Container';
import { Link } from 'react-router-dom';

class ProjectPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isError: false,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    const projectId = this.props.match.params.id;
    //TODO: Move the project data exists check to the action
    if (
      _.isEmpty(this.props.projectData) ||
      !this.props.projectData[projectId]
    ) {
      await this.props.getProjectDetails(projectId);
    }
    this.setState({
      isLoading: false,
    });
  }

  render() {
    const { classes } = this.props;
    const projectId = this.props.match.params.id;
    const project = this.props.projectData[projectId];
    return (
      <main>
        <NavigationBar />
        <Container maxWidth='lg' component='section'>
          <LoadingComponent isLoading={this.state.isLoading}>
            <></>
          </LoadingComponent>
          {!this.state.isLoading && project && (
            <Switch>
              <Route exact path={`${this.props.match.path}/edit`}>
                <>
                  <PageTitle title={'Edit Project'} />
                  <ProjectForm project={project} />
                </>
              </Route>
              <Route exact path={`${this.props.match.path}/create-sprint`}>
                <>
                  <PageTitle title={'Create New Sprint'} />
                  <SprintForm project={project} />
                </>
              </Route>
              <Route path={`${this.props.match.path}/sprints/:sprintid`}>
                <Sprint project={project} />
              </Route>
              <Route exact path={`${this.props.match.path}/`}>
                {!this.state.isLoading && project && (
                  <>
                    <SprintListUser />
                  </>
                )}
              </Route>
            </Switch>
          )}
        </Container>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  projectData: state.project.data,
});
const mapDispatchToProps = (dispatch) => ({
  getProjectDetails: (projectId) => dispatch(getProjectDetails(projectId)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true }
  )(withStyles(projectListPageStyle)(ProjectPage))
);
